<template>
  <div>
    <div class="card">
      <div class="card-header" v-if="!standalone">
        <button type="button" class="close float-left d-md-none mr-3" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="fas fa-arrow-left" aria-hidden="true"></i></span>
        </button>
        <h3 class="card-title" style="margin-left: -0.6rem">Messaggio</h3>

        <div class="card-tools">
          <!-- <a href="#" class="btn btn-tool" title="Previous"><i class="fas fa-chevron-left"></i></a>
          <a href="#" class="btn btn-tool" title="Next"><i class="fas fa-chevron-right"></i></a> -->
          <button type="button" class="close" @click.prevent="closeMessage()">&times;</button>
        </div>
      </div>
      <!-- /.card-header -->
      <div class="card-body p-0" v-if="message">
        <div class="mailbox-read-info">
          <h5>{{ message.headers.subject }}</h5>
          <h6>
            <span class="mailbox-read-time float-right">{{
                message.headers.date
              }}</span>

            <span>Da: - {{ message.headers.from }}</span><br/>
            <span>A: {{ message.headers.to }}</span><br/>
            <span v-if="message.headers.cc">Cc: {{ message.headers.cc }}</span><br/>
            <span v-if="message.headers.bcc">Ccn: {{ message.headers.bcc }}</span><br/>
            <span>Numero Protocollo: {{ message.message.external_id }}</span>
            <br/>
            <span>Data Protocollo: {{ message.message.protocol_date }}</span>
            <div>
              <div>
                Tags:
                <button
                  v-for="tag in addedTags"
                  type="button"
                  class="tag-label"
                  :class="{'can-remove': editingTag}"
                  @click="removeTag(tag)"
                  :disabled="!editingTag"
                >
                  <i
                    v-if="editingTag"
                    class="fa fa-minus mr-1"
                  ></i>
                  {{tag.path}}
                </button>

                <button type="button" class="btn btn-default btn-sm edit-tags-btn"
                  @click.prevent="editingTag = true"
                  v-if="userCan(CUP.MANAGE_TAGS) && !editingTag">
                  <i class="fas fa-pen"></i> Modifica tag
                </button>
                <button type="button" class="btn btn-default btn-sm"
                  @click.prevent="editingTag = false" v-if="editingTag">
                  <i class="fa fa-times"></i> Chiudi
                </button>
              </div>
            </div>
            <div v-if="editingTag">
              <button
                type="button"
                class="tag-label can-add"
                v-for="tag in availableTags"
                @click="setTag(tag)"
              >
                <i
                  v-if="editingTag"
                  class="fa fa-plus mr-1"
                ></i>
                {{tag.name}}
              </button>
            </div>
          </h6>

        </div>
        <div class="mailbox-controls text-right">
          <div v-if="!message.message.is_draft" class="btn-group">
            <button type="button" class="btn btn-default btn-sm" data-container="body" title="Rispondi"
              @click.prevent="writeRefMail('reply')" v-if="userCan(CUP.WRITE_MESSAGES)">
              <i class="fas fa-reply"></i> Rispondi
            </button>
            <button type="button" class="btn btn-default btn-sm" data-container="body" title="Rispondi a tutti"
              @click.prevent="writeRefMail('reply-all')" v-if="userCan(CUP.WRITE_MESSAGES)">
              <i class="fas fa-reply-all"></i> Rispondi a tutti
            </button>
            <button type="button" class="btn btn-default btn-sm" data-container="body" title="Inoltra"
              @click.prevent="writeRefMail('forward')" v-if="userCan(CUP.WRITE_MESSAGES)">
              <i class="fas fa-share"></i> Inoltra
            </button>
            <button type="button" class="btn btn-default btn-sm" data-container="body" title="Info"
              @click.prevent="showInfoModal()" v-if="userCan(CUP.VIEW_LOGS)">
              <i class="fas fa-circle-info"></i> Info
            </button>
            <button type="button" class="btn btn-default btn-sm" data-container="body" title="Scarica"
              @click.prevent="downloadEmail()" v-if="userCan(CUP.DOWNLOAD_MESSAGES)">
              <i class="fas fa-download"></i> Scarica
            </button>
          </div>
          <div v-else class="btn-group">
            <button type="button" class="btn btn-default btn-sm" title="Modifica"
              @click.prevent="editMessage()" v-if="userCan(CUP.WRITE_MESSAGES)">
              <i class="fas fa-pen"></i> Modifica
            </button>
          </div>
        </div>
        <!-- /.mailbox-read-info -->
        <!-- /.mailbox-controls -->
        <div class="container">
          <div class="row mt-3 attachment-list" v-if="message">
            <div v-for="attachment in message.attachments" :key="attachment.filename" class="col-sm-4 attachment-col">
              <div class="border p-3 attachment">
                <div class="container">
                  <div class="row">
                    <div class="col-2">
                      <i class="fas fa-file mr-2"></i>
                    </div>
                    <div class="col-8">
                      {{ attachment.filename }}
                    </div>
                    <div class="col-2">
                      <a @click.prevent="getAttachment(attachment.filename)" href="#" class="btn download-attachment-btn"><i
                          class="fas fa-download"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="message-container">
          <iframe 
            ref="contentIframe"
            sandbox="allow-same-origin"
            v-if="message"
            class="mailbox-read-message"
            :srcdoc="message.body"
            @load="fixIframeSize()"
          ></iframe>
        </div>
        <!-- /.mailbox-read-message -->
      </div>
    </div>
    <!-- /.card-body -->
    <div class="card-footer bg-white"></div>
    <div id="infoModal" class="modal modal-xl fade">
      <div class="modal-dialog">
        <div class="modal-content">
          <form>
            <div class="modal-header">
              <h4 class="modal-title">Azioni effettuate sul messaggio</h4>
              <button type="button" class="close" data-bs-dismiss="modal" aria-hidden="true">&times;</button>
            </div>
            <div class="modal-body">
              <table class="table table table-striped table-lg">
                <thead>
                  <tr>
                    <th>Utente</th>
                    <th>Data</th>
                    <th>Azione</th>
                    <th>Informazioni</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="messageLogs.length == 0">
                    <td colspan=4 class="info-row">Nessuna azione effettuata sul messaggio</td>
                  </tr>
                  <tr v-for="log in messageLogs">
                    <td>{{log.user?.username ?? '(sistema)'}}</td>
                    <td>{{formatDate(log.created_at)}}</td>
                    <td>{{logService.LogActionLabelsAndIcons[log.action][0]}}</td>
                    <td>
                      <span v-if="log.action == logService.LogActions.MessageTagged">
                        <b>Tag:</b> {{ log.data.name }} (id: {{ log.data.id }})
                      </span>
                      <span v-else-if="log.action == logService.LogActions.MessageUntagged">
                        <b>Tag:</b> {{ log.data.name }} (id: {{ log.data.id }})
                      </span>
                      <div v-else-if="log.action == logService.LogActions.MessageAssigned">
                        <span
                          v-for="change in formatAssigneeDiff(log.data)"
                          :class="`assignee-${change.action}`"
                        >
                          <i :class="`fas ${change.action == 'added' ? 'fa-plus' : 'fa-times'}`"></i>
                          {{change.user}}
                        </span>
                      </div>
                      <div v-else-if="log.action == logService.LogActions.StatusChanged">
                        <b>Nuovo stato:</b> {{log.data.status}}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import bus from '@/bus'
import axios from '@/services/axios.setup.js'
import * as messageService from '@/services/message.service.js';
import * as tagService from '@/services/tag.service.js'
import * as logService from '@/services/log.service.js'
import { FOLDERS } from '@/services/message.service.js'
import { CORE_USER_PERMISSIONS as CUP } from '@/enums/CoreUserPermissions';
import { ref, watch, computed, inject, useTemplateRef } from 'vue';
import { useRoute } from 'vue-router';
import { onUnmounted } from 'vue';
import { nextTick } from 'vue';

let props = defineProps(['account', 'auto_read', 'folder', 'message_uuid', 'message_type', 'message_index', 'standalone']);
let emit = defineEmits(['refresh', 'close']);
let userCan = inject('userCan');
let showModal = inject('showModal');
let contentIframe = useTemplateRef('contentIframe');

let message = ref(null);
let messageLogs = ref([]);
let loading = ref(true);
let addedTags = ref([]);
let editingTag = ref(false);
let accountTags = ref([]);
let availableTags = computed(() => {
  if (!message) return [];
  // Filter all tags looking for the ones that are not
  // already attached to the message.
  let attachedTagsIds = new Set(addedTags.value.map(t => t.id));
  return accountTags.value.filter((tag) => !attachedTagsIds.has(tag.id));
});
let route = useRoute();

watch(() => props.message_uuid, (newValue, oldValue) => {
  loadMessage();
});

async function getAttachment(name) {
  let folderSlug = props.folder;

  if (!props.folder) {
    const folders = await messageService.getAllFolders(props.account);
    const folder = folders.find(f => f.id == message.value.message.folder_id);
    folderSlug = folder.slug;
  }

  let url = `/accounts/${props.account}/messages/${props.message_uuid}/attachments/${name}`
  let response = await axios({
    url: url,
    method: 'GET',
    responseType: 'blob'
  });

  var fileURL = window.URL.createObjectURL(new Blob([response.data]))
  var fileLink = document.createElement('a')

  fileLink.href = fileURL
  fileLink.setAttribute('download', name)
  document.body.appendChild(fileLink)

  fileLink.click()
}

async function loadMessage() {
  loading.value = true;
  let type = props.message_type;
  if (type == 'receipt') {
    props.folder = FOLDERS.RECEIPTS;
  }
  let url = `/accounts/${props.account}/messages/${props.message_uuid}`

  let r = await axios.get(url);
  message.value = r.data;
  loading.value = false;
  addedTags.value = message.value.navigation_tags ?? [];

  if (props.auto_read == 1 && props.message_type != 'sent') {
    let index = props.message_index
    if (index == null) {
      index = 0;
    }
    bus.$emit('read', {message: message.value, uuid: props.message_uuid, index})
  }

  // A volte l'evento "load" è un po' troppo lento, quindi iniziamo
  // prima a sistemare l'altezza dell'iframe.
  setTimeout(fixIframeSize, 100);
}

async function editMessage() {
  const uuid = props.message_uuid;
  const popup = window.open(
    `/messages/new?id=${uuid}&account=${props.account}&folder=DRAFTS`,
    `Scrivi mail ${uuid}`,
    'width=1000; height=700'
  );
}

/** @param {'reply'|'reply-all'|'forward'} type */
async function writeRefMail(type) {
  const res = await messageService.createDraft(
    props.account,
    message.value.message.uuid,
    (type == 'reply-all') ? 'reply' : type
  );

  const draft = await messageService.get(props.account, res.uuid);

  const _ = await messageService.updateDraft(props.account, {
    uuid: res.uuid,
    to: res.to,
    cc: res.cc,
    bcc: res.bcc,
    body: draft.body
  });

  const popup = window.open(
    `/messages/new?id=${res.uuid}&account=${props.account}&folder=${props.folder}&type=${type}&ref-id=${message.value.message.uuid}`,
    `Scrivi mail ${res.uuid}`,
    `width=1000; height=700`
  )
}

async function showInfoModal() {
  showModal('infoModal');
  messageLogs.value = await logService.getForMessage(message.value.message.id);
  for (let log of messageLogs.value) {
    log.data = JSON.parse(log.data);
  }
}

function formatDate(dateString) {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('default', {
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit'
  }).format(date);
}

function formatAssigneeDiff(diff) {
  let actions = [];

  for (let user of diff.newAssignee) {
    if (!diff.previousAssignee.includes(user)) {
      actions.push({ user, action: 'added' });
    }
  }

  for (let user of diff.previousAssignee) {
    if (!diff.newAssignee.includes(user)) {
      actions.push({ user, action: 'removed' });
    }
  }

  return actions;
}

async function getTags() {
  let tags = await tagService.getAccountTags(props.account);
  accountTags.value = tags;
}

async function setTag(tag) {
  await tagService.attach(props.account, tag.id, message.value.message.id)
  // This make the interaction a little faster, by preventing
  // waiting for the full message to come back in order to
  // show the tag appended to the list.
  let added = {...tag, path: tag.name};
  addedTags.value.push(added);
  addedTags.value.sort((a, b) => a.id - b.id);

  if (route.params?.tag == tag.id) {
    emit('refresh');
  }

  await loadMessage();
}

async function removeTag(tag) {
  await tagService.detach(props.account, tag.id, message.value.message.id)
  // Same as the "setTag" function, it just make the operation snappier
  addedTags.value = addedTags.value.filter((t) => t.id != tag.id);

  if (route.params?.tag == tag.id) {
    emit('refresh');
  }

  await loadMessage();
}

async function downloadEmail() {
  await messageService.downloadMessage(
    props.account,
    message.value.message.uuid,
    message.value.message.subject
  );
}

function closeMessage() {
  emit('close');
}

function fixIframeSize() {
  if (!contentIframe.value) return;
  const height = contentIframe.value.contentDocument.documentElement.getBoundingClientRect().height;
  contentIframe.value.style.height = `${height}px`;
}

// init
loadMessage();
getTags();

bus.$on('tagRemoved', getTags);
bus.$on('tagAdded', getTags);

onUnmounted(() => {
  bus.$off('tagRemoved', getTags);
  bus.$off('tagAdded', getTags);
});
</script>

<style>
.modal-xl {
  min-width: 99%;
  width: 99%;
}

.tag-label {
  font-size: 0.9em;
  font-weight: normal;
  margin-right: 10px;
  background-color: #ededed;
  padding: 4px 8px;
  border: solid 0px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color .2s;
}

.tag-label:disabled {
  background-color: #ededed;
  color: #000;
  cursor: default;
}

.tag-label:not(:disabled):hover {
  background-color: #ccc;
}

.tag-label.can-remove {
  border: solid 1px #f55;
}

.tag-label.can-add {
  border: solid 1px #5a5;
}

.assignee-added, .assignee-removed {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.9em;
  border-radius: 3px;
  padding-inline: 4px;
  margin-right: 6px;
}

.assignee-added {
  background-color: #282;
  color: #fff;
}

.assignee-removed {
  background-color: #a22;
  color: #fff;
}

table .info-row {
  text-align: center;
  font-style: italic;
}

.mailbox-read-message {
  width: 100%;
  box-sizing: content-box;
  padding: 0px;
}

.message-container {
  padding: 10px;
}

@media print {
  .edit-tags-btn {
    display: none !important;
  }

  .mailbox-controls {
    display: none;
  }

  .attachment-list {
    display: block !important;
  }

  .attachment-col {
    flex: 0 0 auto !important;
    max-width: none !important;
    width: auto !important;
  }

  .border.p-3.attachment {
    padding: 0px !important;
    border: solid 0px !important;

    .row {
      .col-2 {
        flex-basis: 0px !important;
        flex-grow: 0 !important;
        padding-right: 0px !important;
      }
      .col-8 {
        padding-left: 0px !important;
      }
      .download-attachment-btn {
        display: none !important;
      }
    }
  }
}
</style>
